import uiConfig from 'src/lib/ui/config';

const button = {
  labelOffsetY: -1,
  fontSize: 46,
  width: 240,
  height: 100,
  centerOnOrigin: true,
  font: 'Body',
} as const;

const separator = {
  height: 3,
  width: 500,
  y: 125,
  backgroundColor: '#e7b77e',
  centerOnOrigin: true,
};

const message = {
  color: '#b68351',
  size: 40,
  align: 'center',
  centerOnOrigin: true,
  font: 'Body',
  width: 432,
  height: 48,
  y: 100,
} as const;

const warning = {
  color: '#b68351',
  size: 22,
  align: 'center',
  verticalAlign: 'center',
  centerOnOrigin: true,
  font: 'Body',
  width: 300,
  height: 35,
  y: 355,
} as const;

const frame = {
  height: 160,
  y: 240,
  image: 'assets/ui/shared/frames/scroller_panel_blue.png',
  scaleMethod: '9slice',
  sourceSlices: {
    vertical: { top: 35, bottom: 35 },
    horizontal: { left: 35, right: 35 },
  },
  centerOnOrigin: true,
} as const;

const playerName = {
  x: 145,
  width: 360,
  align: 'center',
  verticalAlign: 'center',
  font: 'Body',
  size: 35,
  color: '#947372',
} as const;

const messageMulti = {
  ...message,
  y: 115,
  width: 490,
  height: 70,
} as const;

const separatorMulti = {
  ...separator,
  y: 160,
};

const frameMulti = {
  height: 200,
  y: 280,
  flex: {
    flexWrap: 'wrap',
    alignContent: 'center',
    justifyContent: 'center',
  },
  centerOnOrigin: true,
} as const;

const warningMulti = {
  ...warning,
  width: 500,
  height: 75,
  y: 425,
  wordWrap: true,
};

const rootMulti = {
  zIndex: 10000,
  width: uiConfig.popups.buruburu.width,
  height: 600,
  darkerBg: false,
};

export const energyGiftConfirmation = {
  button,
  separator,
  message,
  frame,
  playerName,
  warning,
  messageMulti,
  separatorMulti,
  frameMulti,
  warningMulti,
  rootMulti,
};
